export default __webpack_public_path__ + "static/media/logo-dark.83ed783d.png";